var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3535 17.3536C12.1583 17.5488 11.8417 17.5488 11.6464 17.3536L8.46444 14.1716C8.26918 13.9763 8.26918 13.6597 8.46444 13.4645C8.6597 13.2692 8.97628 13.2692 9.17155 13.4645L11.5 15.7929V3C11.5 2.72386 11.7238 2.5 12 2.5C12.2761 2.5 12.5 2.72386 12.5 3V15.7929L14.8284 13.4645C15.0237 13.2692 15.3402 13.2692 15.5355 13.4645C15.7308 13.6597 15.7308 13.9763 15.5355 14.1716L12.3535 17.3536Z",
    fill: "#4C54A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14.5C3.27615 14.5 3.5 14.7239 3.5 15V19.2857C3.5 19.4842 3.50615 19.7276 3.72856 19.95C3.96509 20.1865 4.55206 20.5 6 20.5H18.5C19.6748 20.5 20.1245 20.1982 20.3034 19.9835C20.4914 19.7578 20.5 19.4959 20.5 19.2857V15C20.5 14.7239 20.7239 14.5 21 14.5C21.2761 14.5 21.5 14.7239 21.5 15L21.5 19.2981C21.5002 19.5259 21.5006 20.1089 21.0716 20.6237C20.6255 21.159 19.8252 21.5 18.5 21.5H6C4.44795 21.5 3.53492 21.1706 3.02145 20.6571C2.49975 20.1354 2.49993 19.5295 2.5 19.2936L2.5 15C2.5 14.7239 2.72386 14.5 3 14.5Z",
    fill: "#4C54A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportBlue);
export default __webpack_public_path__ + "static/media/export_blue.8ac0bd06ea53840c920fa927b4beb9b3.svg";
export { ForwardRef as ReactComponent };